/** @jsxImportSource @emotion/react */
import React from "react";
import "../../../pages/Trade/index.css";
import { Token } from "../../../store/global/TokenEnum";
import SelectedTokensButton from "../../ButterComponents/SelectedTokenButton/SelectedTokenButton";
import styled from "@emotion/styled";
import { PropsOf, css } from "@emotion/react";
import { removeTokenFromStore } from "utils/tokenSelectorUtils";
import { ReactComponent as PlusIcon } from "../../../img/butter_svgs/PlusIcon.svg";
import { FlexContainer } from "../../../containers/FlexContainer";
import { Button } from "../../general/Button/Button";
import { CounterParty } from "../TradeLegMaker";

export interface TokenSectionProps {
  symbol: Token;
  showPlusButton: boolean;
  counterParty: CounterParty;
  setIsWaitingToAddToken: React.Dispatch<React.SetStateAction<boolean>>;
  setIsChangingToken?: React.Dispatch<React.SetStateAction<Token | undefined>>;
  hideBalancePercentages: () => void;
  isWaitingToAddToken?: boolean;
}

export const TokenInputSection: React.FC<TokenSectionProps> = ({
  symbol,
  showPlusButton,
  counterParty,
  setIsWaitingToAddToken,
  setIsChangingToken,
  hideBalancePercentages,
  isWaitingToAddToken,
}) => {
  return (
    <Container
      onClick={() => {}}
      data-testid={`token-input-section-${!symbol ? "empty" : "nonEmpty"}-label`}
    >
      <SelectedTokensButton
        isVisible={true}
        symbol={symbol}
        onClick={() => {
          if (setIsChangingToken) {
            setIsChangingToken(symbol);
          }
        }}
        removeToken={() => {
          removeTokenFromStore(counterParty, symbol);
        }}
      />
      {showPlusButton && (
        <PlusButton
          isDisabled={isWaitingToAddToken ?? true}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            hideBalancePercentages();
            setIsWaitingToAddToken(true);
          }}
        />
      )}
    </Container>
  );
};

// Sub-components

const Container = styled.div(() => {
  return { display: "flex", gap: 4, alignItems: "center" };
});

export const PlusButton = ({
  isDisabled,
  onClick,
}: {
  isDisabled: boolean;
  onClick: PropsOf<typeof Button>["onClick"];
}) => {
  return (
    <Button
      isDisabled={isDisabled}
      textSize="Extra Large"
      buttonType="quaternary"
      buttonCss={css`
        display: flex;
        padding: 6px;
        justify-content: center;
        align-items: center;
        gap: 2px;
        height: 36px;
        aspect-ratio: 1 / 1;
      `}
      onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
    >
      <FlexContainer
        css={css`
          justify-content: center;
          height: 20px;
          width: 20px;
        `}
      >
        <PlusIcon width={10} height={10} />
      </FlexContainer>
    </Button>
  );
};
